<template>
	<!-- <aside class="main-sidebar elevation-4 sidebar-light-info"> -->
	<aside class="main-sidebar sidebar-light-info">
		<!-- style="vertical-align: middle; height: 45px" -->
		<div>
			<a href="/dash" class="brand-link bg-white d-none">
				<img
					src="/adminlte/dist/img/logo_white.png"
					:alt="$store.state.app.name"
					class="brand-image elevation-3 d-none"
					style="opacity: 0.8"
				/>
				<img
					src="/adminlte/dist/img/logo_white.png"
					style="vertical-align: middle; height: 50px; width: 175px"
					class="align-middle img-fluid rounded"
				/>
			</a>
			<a href="/dash" class="brand-link bg-white logo-switch elevation-1">
				<!-- src="/images/speke_logo_small.png" -->
				<img
					src="/images/final_elephant.png"
					style="vertical-align: middle; height: 45px; opacity: 0.8"
					alt="AdminLTE Logo"
					class="brand-image brand-image-xs img-circle logo-xs text-start center-block"
				/>
				<!-- src="/images/speke_logo.webp" -->
				<img
					src="/images/speke_banner_black.png"
					style="vertical-align: middle; height: 60px; width: 175px"
					alt="AdminLTE Logo"
					class="brand-image brand-image-xl logo-xl center-block"
				/>
			</a>
		</div>

		<div class="sidebar">
			<!-- <div class="user-panel pb-3 mb-3 d-flex d-none"></div> -->
			<!-- <div class="user-panel mt-3 pb-3 mb-3 d-flex border-top-1 d-none">
				<div class="image">
					<img
						src="/adminlte/dist/img/placeholder.jpg"
						class="img-circle elevation-2"
						alt="User Image"
					/>
				</div>
				<div class="info">
					<a href="#" class="d-block">Alexander Pierce</a>
				</div>
			</div> -->

			<div class="form-inline d-none">
				<div class="input-group" data-widget="sidebar-search">
					<input
						class="form-control form-control-sidebar"
						type="search"
						placeholder="Search"
						aria-label="Search"
					/>
					<div class="input-group-append">
						<button class="btn btn-sidebar">
							<i class="fas fa-search fa-fw"></i>
						</button>
					</div>
				</div>
			</div>

			<nav class="mt-2">
				<ul
					class="nav nav-pills nav-sidebar flex-column nav-flat"
					data-widget="treeview"
					role="menu"
					data-accordion="false"
				>
					<!-- <li class="nav-header font-size-18 font-weight-bold">Dashboards:</li> -->
					<nav-item
						icon="fas fa-home"
						link="/dash"
						style="font-family: NunitoBlack"
						>Dashboards</nav-item
					>
					<!-- <li class="nav-header font-size-15 font-weight-bold"> Item Registers: </li> -->

					<li
						class="nav-item has-treeview"
						:class="{ 'menu-open': isTopLevelActive('reservations') }"
					>
						<!-- @click.prevent="toggleMenu('licensee')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<i class="nav-icon fas fa-handshake"></i>
							<p>
								Sales & Reservations
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'reservations' }"
						>
							<nav-item
								icon="far fa-circle"
								link="/reservations/schedule"
								style="font-family: OpenSansRegular"
								>Tour Register</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/reservations/booking"
								style="font-family: OpenSansRegular"
								>Booking Forms</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/reservations/costing"
								style="font-family: OpenSansRegular"
								>Tour Costing</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/reservations/summary"
								style="font-family: OpenSansRegular"
								>Tour Summaries</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/reservations/invoice"
								style="font-family: OpenSansRegular"
								>Tour Invoices</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/reservations/quotes"
								style="font-family: OpenSansRegular"
								>Tour Quotes</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/reservations/permits"
								style="font-family: OpenSansRegular"
								>Tour Permits</nav-item
							>
						</ul>
					</li>
					<li
						class="nav-item has-treeview"
						:class="{ 'menu-open': isTopLevelActive('finance') }"
					>
						<!-- @click.prevent="toggleMenu('otherPages')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<i class="nav-icon fas fa-hand-holding-usd"></i>
							<p>
								Finance
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'finance' }"
						>
							<nav-item
								icon="far fa-circle"
								link="/finance/schedule"
								style="font-family: OpenSansRegular"
								>Tour Register</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/finance/costing"
								style="font-family: OpenSansRegular"
								>Tour Costing</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/finance/invoices"
								style="font-family: OpenSansRegular"
								>Tour Invoices</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/finance/quotes"
								style="font-family: OpenSansRegular"
								>Quotations</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/finance/payments"
								style="font-family: OpenSansRegular"
								>Supplier Payments</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/finance/permits"
								style="font-family: OpenSansRegular"
								>Tour Permits</nav-item
							>
						</ul>
					</li>
					<li
						class="nav-item has-treeview"
						:class="{ 'menu-open': isTopLevelActive('operations') }"
					>
						<!-- @click.prevent="toggleMenu('otherPages')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<i class="nav-icon fas fa-paw"></i>
							<p>
								Operations
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'operations' }"
						>
							<nav-item
								icon="far fa-circle"
								link="/operations/schedule"
								style="font-family: OpenSansRegular"
								>Tour Register</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/operations/itinerary"
								style="font-family: OpenSansRegular"
								>Tour Itineraries</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/operations/booking"
								style="font-family: OpenSansRegular"
								>Booking Forms</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/operations/invoice"
								style="font-family: OpenSansRegular"
								>Tour Invoices</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/operations/budgeting"
								style="font-family: OpenSansRegular; margin-right: 20px"
								>Tour Budgeting</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/operations/allocations"
								style="font-family: OpenSansRegular; margin-right: 20px"
								>Tour Allocation</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/operations/requisitions"
								style="font-family: OpenSansRegular; margin-right: 20px"
								>Tour Requisitions</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/operations/permits"
								style="font-family: OpenSansRegular"
								>Tour Permits</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/operations/payments"
								style="font-family: OpenSansRegular; margin-right: 20px"
								>Supplier Payments</nav-item
							>
						</ul>
					</li>

					<li
						class="nav-item has-treeview d-none"
						:class="{ 'menu-open': isTopLevelActive('human') }"
					>
						<!-- @click.prevent="toggleMenu('otherPages')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<i class="nav-icon fas fa-user-friends"></i>
							<p>
								Human Resource
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'human' }"
						>
							<nav-item
								icon="far fa-circle"
								link="/human/information"
								style="font-family: OpenSansRegular"
								>Staff Information</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/leave"
								style="font-family: OpenSansRegular"
								>Leave Management</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/attendance"
								style="font-family: OpenSansRegular"
								>AttendanceManagement</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/performance"
								style="font-family: OpenSansRegular"
								>Performance Management</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/events"
								style="font-family: OpenSansRegular"
								>Event Management</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/compensation"
								style="font-family: OpenSansRegular"
								>Compensation & Benefits</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/engagement"
								style="font-family: OpenSansRegular"
								>Engagement & Feedback</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/exit"
								style="font-family: OpenSansRegular"
								>Off Boarding</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/human/policies"
								style="font-family: OpenSansRegular"
								>Policy Documents</nav-item
							>
						</ul>
					</li>
					<li
						class="nav-item has-treeview"
						:class="{ 'menu-open': isTopLevelActive('permits') }"
					>
						<!-- @click.prevent="toggleMenu('otherPages')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<!-- <i class="nav-icon fas fa-hippo"></i> -->
							<font-awesome-icon
								class="nav-icon"
								:icon="['fab', 'mailchimp']"
								size="2x"
							/>
							<p>
								Tour Permits
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'permits' }"
						>
							<nav-item
								icon="far fa-circle"
								link="/permits/schedule"
								style="font-family: OpenSansRegular"
								>Tour Register</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/permits/booking"
								style="font-family: OpenSansRegular"
								>Booking Forms</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/permits/invoices"
								style="font-family: OpenSansRegular"
								>Tour Invoices</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/permits/budgeting"
								style="font-family: OpenSansRegular; margin-right: 20px"
								>Tour Budgeting</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/permits/requisitions"
								style="font-family: OpenSansRegular; margin-right: 20px"
								>Tour Requisitions</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/permits/permits"
								style="font-family: OpenSansRegular"
								>Tour Permits</nav-item
							>
						</ul>
					</li>
					<li
						class="nav-item has-treeview d-none"
						:class="{ 'menu-open': isTopLevelActive('fleet') }"
					>
						<!-- @click.prevent="toggleMenu('otherPages')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<i class="nav-icon fas fa-car"></i>
							<p>
								Fleet Management
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'fleet' }"
						>
							<nav-item
								icon="far fa-circle"
								link="#"
								style="font-family: OpenSansRegular"
								>Other View</nav-item
							>
						</ul>
					</li>
					<li
						class="nav-item has-treeview"
						:class="{ 'menu-open': isTopLevelActive('settings') }"
					>
						<!-- @click.prevent="toggleMenu('otherPages')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<i class="nav-icon fas fa-cog"></i>
							<p>
								Settings
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'settings' }"
						>
							<nav-item
								icon="far fa-circle"
								link="/masters/agents"
								style="font-family: OpenSansRegular"
								>Reservation Master</nav-item
							>
							<nav-item
								class="d-none"
								icon="far fa-circle"
								link="/masters/locations"
								style="font-family: OpenSansRegular"
								>Locations Master</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/operations"
								style="font-family: OpenSansRegular"
								>Operations Master</nav-item
							>
						</ul>
					</li>
					<li
						class="nav-item has-treeview d-none"
						:class="{ 'menu-open': isTopLevelActive('masters') }"
					>
						<!-- @click.prevent="toggleMenu('otherPages')" -->
						<a class="nav-link" style="font-family: NunitoBlack">
							<i class="nav-icon fas fa-stream"></i>
							<p>
								Masters
								<i class="right fas fa-angle-right"></i>
							</p>
						</a>
						<ul
							class="nav nav-treeview"
							:class="{ 'menu-hidden': activeMenu !== 'masters' }"
						>
							<nav-item
								icon="far fa-circle"
								link="/masters/agents"
								style="font-family: OpenSansRegular"
								>Agents</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/lodges"
								style="font-family: OpenSansRegular"
								>Lodges</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/boats"
								style="font-family: OpenSansRegular"
								>Boats</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/flights"
								style="font-family: OpenSansRegular"
								>Flights</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/vehicles"
								style="font-family: OpenSansRegular"
								>Vehicles</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/guides"
								style="font-family: OpenSansRegular"
								>Guides</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/tourists"
								style="font-family: OpenSansRegular"
								>Tourists</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/meals"
								style="font-family: OpenSansRegular"
								>Meals</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/human"
								style="font-family: OpenSansRegular"
								>Human Resource</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/pricing"
								style="font-family: OpenSansRegular"
								>Pricing</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/activity"
								style="font-family: OpenSansRegular"
								>Activities</nav-item
							>
							<nav-item
								icon="far fa-circle"
								link="/masters/suppliers"
								style="font-family: OpenSansRegular"
								>Other View</nav-item
							>
						</ul>
					</li>
					<!-- <li class="nav-header">Budgeting Section</li> -->
				</ul>
			</nav>
		</div>
	</aside>
</template>

<script>
import NavItem from "./Navitem.vue";
export default {
	data() {
		return {
			activeMenu: null, // Tracks the currently active menu
		};
	},
	components: {
		NavItem,
	},
	methods: {
		isActive_() {
			if (typeof this.link === "object") {
				return this.$route.name === this.link.name;
			} else {
				return this.$route.path === this.link;
			}
		},
		// Method to check if a sub-menu item is active
		isActive(routeName) {
			return this.$route.name === routeName;
		},

		// Method to check if any sub-menu item under the top-level is active
		isTopLevelActive(menuName) {
			return this.activeMenu === menuName || this.isSecondLevelActive(menuName);
		},
		isSecondLevelActive(menuName) {
			// Add second level routes for each top level menu
			const secondLevelRoutes = {
				reservations: [
					"SalesSchedule",
					"SalesItinerary",
					"SalesCosting",
					"SalesBooking",
					"SalesSummary",
					"TourInvoiceSales",
					"TourQuoteSales",
					"TourPermitSales",
				],
				operations: [
					"TourScheduleOps",
					"TourItineraryOps",
					"BookingFormOps",
					"OperationsBudgeting",
					"OperationsSafaris",
					"OperationsAllocations",
					"OperationsRequisition",
					"TourInvoiceOps",
					"FinanceQuotesOps",
					"TourPermitOps",
					"OperationsPayments",
				],
				finance: [
					"TourScheduleFinance",
					"FinanceInvoices",
					"FinanceCosting",
					"FinanceQuotes",
					"FinancePayments",
					"TourPermitFinance",
					"OpsPaymentsFinance",
				],
				human: [
					"StaffInformation",
					"LeaveManagement",
					"AttendanceManagement",
					"PerformanceManagement",
					"EventManagement",
					"CompensationBenefits",
					"EngagementFeedback",
					"OffBoarding",
					"PolicyDocuments",
				],
				fleet: [
					"TourScheduleFleet",
					"OpsAllocationFleet",
					"FleetVehicles",
					"FleetService",
					"FleetRepairs",
					"FleetGarage",
					"InventoryFleet",
				],
				permits: [
					"TourSchedulePermits",
					"PermitsBudgeting",
					"PermitsRequisition",
					"ItineraryPermits",
					"FinancePaymentsPermits",
					"PermitsBooking",
					"PermitsInvoices",
					"AllPermits",
					// "FinanceInvoicesPermits",
					"TourPermits",
					"HeldPermits",
					"BookedPermits",
				],
				settings: [
					"UsersRoles",
					"Reminders",
					"ReservationMaster",
					"LocationsMaster",
					"OperationsMaster",
				],
				masters: [
					"ReservationMaster",
					"LodgesMaster", // same as accomodation
					"BoatsMaster",
					"FlightsMaster",
					"VehiclesMaster",
					"GuidesMaster",
					"TouristMaster",
					"MealsMaster",
					"HumanMaster",
					"PricingMaster",
					"ActivityMaster",
					"SuppliersMaster",
				],
			};
			return secondLevelRoutes[menuName]?.includes(this.$route.name);
		},
		isThirdLevelActive(menuName) {
			// Add third level routes for each second level menu
			const thirdLevelRoutes = {
				permits: [
					"AllPermits",
					"BookedPermits",
					"PaidPermits",
					"SectorPermits",
					"TrackPermits",
				],
				payments: [
					"AllPayments",
					"PendingPayments",
					"ApprovedPayments",
					"PaidPayments",
					"CancelledPayments",
				],
			};
			return thirdLevelRoutes[menuName]?.includes(this.$route.name);
		},
		// Method to toggle the menu
		toggleMenu(menuName) {
			// Toggle the active menu only if it is not already active.
			if (this.activeMenu !== menuName) {
				this.activeMenu = menuName;
			} else {
				this.activeMenu = null; // Close it when clicked again
			}
		},
	},
};
</script>

<style>
/* Ensure this overrides AdminLTE styles */
.main-sidebar .nav-link.active {
	background-color: #526635 !important;
	color: white !important;
	/* color: #051837 !important; */
}

.main-sidebar .nav-treeview .nav-link.active {
	/* background-color: #52be80 !important; */
	background-color: #526635 !important;
	color: white !important;
	/* color: #051837 !important; */
}

/* Submenus hidden by default */
.nav-treeview {
	display: none;
}

/* Show submenus when the top-level menu is open */
.menu-open .nav-treeview {
	display: block !important;
}

/* Explicitly hide submenus when their top-level menu is not active */
.menu-hidden {
	display: none !important;
}
</style>


